// import React, { useEffect } from "react";
// import { motion } from "framer-motion";
// import { useLanguage } from "../../contexts/LanguageContext";
// import { terms } from "../../utils/translations";
// import useIsMobilei from "../../hooks/isMobile"; 
// import "./terms.css";

// export default function Terms() {
//   const { isMobilei } = useIsMobilei(); 
//   const { language } = useLanguage();
//   const isRtl = language === "ar";

//   useEffect(() => {
//     window.scrollTo(0, 0);
//   }, []);

//   return (
//     <div className={`terms-mainDiv ${language === "ar" ? "arab" : ""}`}>
//     <motion.div 
//       style={{marginTop : isMobilei ? "0" : "40px"}}
//       initial={{ opacity: 0, y: 20 }} 
//       animate={{ opacity: 1, y: 0 }} 
//       transition={{ duration: 0.5 }}
//       className={`terms-container ${isRtl ? "rtl" : ""}`}>
      
//       {[
//         { header: terms[language].welcome, texts: [
//           terms[language].termsDescription,
//           terms[language].viVaaDescription,
//           terms[language].customizationDescription,
//           terms[language].greetingsDescription
//         ]},
//         { header: terms[language].aboutUsTitle, texts: [
//           terms[language].aboutUsDescription,
//           terms[language].privacyDescription,
//           terms[language].locationDescription,
//           terms[language].contactEmail
//         ]},
//         { header: terms[language].goalTitle, texts: [
//           terms[language].goalDescription1,
//           terms[language].goalDescription2,
//           terms[language].goalDescription3,
//           terms[language].goalDescription4
//         ]},
//         { header: terms[language].accountTitle, texts: [
//           terms[language].accountDescription1,
//           terms[language].accountDescription2,
//           terms[language].accountDescription3
//         ]},
//         { header: terms[language].iiiTitle, texts: [
//           terms[language].iii1,
//         ]},
//         { header: terms[language].oooTitle, texts: [
//           terms[language].ooo1
//         ]},
//         { header: terms[language].lllTitle, texts: [
//           terms[language].lll1,
//         ]},
//         { header: terms[language].gggTitle, texts: [
//           terms[language].ggg1,
//         ]},
//         { header: terms[language].pppTitle, texts: [
//           terms[language].ppp1,
//         ]},
//         { header: terms[language].hhhTitle, texts: [
//           terms[language].hhh1,
//         ]},
//         { header: terms[language].uuuTitle, texts: [
//           terms[language].uuu1,
//         ]}
//       ].map((section, index) => (
//         <motion.div 
//           key={index} 
//           initial={{ opacity: 0, y: 20 }} 
//           animate={{ opacity: 1, y: 0 }} 
//           transition={{ duration: 0.6, delay: index * 0.2 }}
//           className="terms-section"
//         >
//           <motion.p 
//             className="terms-sectionHeader" 
//             initial={{ scale: 0.8 }} 
//             animate={{ scale: 1 }}
//             transition={{ duration: 0.4 }}
//           >
//             {section.header}
//           </motion.p>
//           {section.texts.map((text, i) => (
//             <motion.p 
//               key={i} 
//               className="terms-sectionText" 
//               initial={{ opacity: 0, x: -10 }} 
//               animate={{ opacity: 1, x: 0 }} 
//               transition={{ delay: index * 0.2 + i * 0.1 }}
//             >
//               {text}
//             </motion.p>
//           ))}
//         </motion.div>
//       ))}
//     </motion.div>
//     </div>
//   );
// }

import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { useLanguage } from "../../contexts/LanguageContext";
import { terms } from "../../utils/translations";
import useIsMobilei from "../../hooks/isMobile"; 
import "./terms.css";

export default function Terms() {
  const { isMobilei } = useIsMobilei(); 
  const { language } = useLanguage();
  const isRtl = language === "ar";

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className={`terms-mainDiv ${language === "ar" ? "arab" : ""}`}>
      <motion.div 
        style={{ marginTop: isMobilei ? "0" : "40px" }}
        initial={{ opacity: 0, y: 20 }} 
        animate={{ opacity: 1, y: 0 }} 
        transition={{ duration: 0.5 }}
        className={`terms-container ${isRtl ? "rtl" : ""}`}>
        
        {[
          { header: terms[language].TermsOfUse, texts: [
            terms[language].TermsOfUse1,
            terms[language].TermsOfUse2,
            terms[language].TermsOfUse3,
            terms[language].TermsOfUse4
          ]},
          { header: terms[language].AboutUs, texts: [
            terms[language].AboutUs1,
            terms[language].AboutUs2,
            terms[language].AboutUs3,
            terms[language].AboutUs4
          ]},
          { header: terms[language].ourGoal, texts: [
            terms[language].ourGoal1,
            terms[language].ourGoal2,
            terms[language].ourGoal3,
            terms[language].ourGoal4
          ]},
          { header: terms[language].yourAccount, texts: [
            terms[language].yourAccount1,
            terms[language].yourAccount2,
            terms[language].yourAccount3
          ]},
          { header: terms[language].serviceAvailability, texts: [
            terms[language].serviceAvailability1,
          ]},
          { header: terms[language].giftDesign, texts: [
            terms[language].giftDesign1
          ]},
          { header: terms[language].celebrityGreetingRequest, texts: [
            terms[language].celebrityGreetingRequest1,
          ]},
          { header: terms[language].pricingAndPayment, texts: [
            terms[language].pricingAndPayment1,
          ]},
          { header: terms[language].electronicPaymentTermsOfUse, texts: [
            terms[language].electronicPaymentTermsOfUse1,
          ]},
          { header: terms[language].ourLocationAndServices, texts: [
            terms[language].ourLocationAndServices1,
          ]},
          { header: terms[language].complaintsAndSuggestions, texts: [
            terms[language].complaintsAndSuggestions1,
          ]}
        ]
        .filter(section => section.header && section.header.trim() !== "") // فلترة العناوين الفارغة
        .map((section, index) => (
          <motion.div 
            key={index} 
            initial={{ opacity: 0, y: 20 }} 
            animate={{ opacity: 1, y: 0 }} 
            transition={{ duration: 0.6, delay: index * 0.2 }}
            className="terms-section"
          >
            <motion.p 
              className="terms-sectionHeader" 
              initial={{ scale: 0.8 }} 
              animate={{ scale: 1 }}
              transition={{ duration: 0.4 }}
            >
              {section.header}
            </motion.p>
            {section.texts
              .filter(text => text && text.trim() !== "") // فلترة النصوص الفارغة
              .map((text, i) => (
                <motion.p 
                  key={i} 
                  className="terms-sectionText" 
                  initial={{ opacity: 0, x: -10 }} 
                  animate={{ opacity: 1, x: 0 }} 
                  transition={{ delay: index * 0.2 + i * 0.1 }}
                >
                  {text}
                </motion.p>
              ))}
          </motion.div>
        ))}
      </motion.div>
    </div>
  );
}
